import { IconLookup } from "@fortawesome/fontawesome-svg-core";
import { LocationDescriptor } from "history";
import React, { useCallback } from "react";
import { useHistory, useLocation } from "react-router";

import { Btn, BtnLayout, BtnType } from "@/mk2/components/Btn";
import {
    HistoryLocationState,
    HistoryLocationWithState,
    goBackInPWA,
} from "@/mk2/services/browserHistory";
import { useNavigateBackport } from "@/mk2/services/historyBackports";

interface OwnProps {
    className?: string;
    icon?: string | IconLookup;
    asAnchor?: boolean;
    link: LocationDescriptor;
    layout?: BtnLayout;
    type?: BtnType;
    label?: React.ReactNode;
    "data-cy"?: string;
}

type Props = OwnProps;

export const BackBtn: React.FC<Props> = ({
    className,
    icon,
    link,
    asAnchor,
    layout = BtnLayout.Icon,
    label,
    type,
    "data-cy": dataCy,
}) => {
    const history = useHistory<HistoryLocationState>();
    const routeNavigate = useNavigateBackport(history);
    const location: HistoryLocationWithState = useLocation();

    const onClick = useCallback(
        (event: React.MouseEvent<HTMLButtonElement>) => {
            event.preventDefault();
            event.stopPropagation();

            goBackInPWA(routeNavigate, location, link);
        },
        [history, link],
    );

    return (
        <Btn
            layout={layout}
            icon={icon}
            className={className}
            link={link}
            asAnchor={asAnchor}
            onClick={!asAnchor ? onClick : undefined}
            label={label}
            type={type}
            data-cy={dataCy}
        />
    );
};
